import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/concentracion';
import Concentracion from './Concentracion';


const ms2p = (state) => {
  return {
    ...state.rs_concentracion,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Concentracion);